//Models
PJQ.models.dailyReports.InspectionLog = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	notifyName: 'Inspection Log',
	endpoint: function () {
		let params = null;
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'inspectionlogs',
				value: this.id
			}
		], params);
	},
	afterInit: function(){

	},
	parse: function (model) {
		if(model != null){
			if (model.contact) {
				this.contact = new PJQ.models.projectContacts.ProjectContact(model.contact);
			}
			else{
				this.contact = null;
			}

			this.attachments = new PJQ.collections.dailyReports.InspectionLogAttachments(model.attachments);
			this.attachments.on('update', _.bind(function(){
				this.isDirty = true;
			}, this));
		}
		return model;
	},
	beforeSave: function () {
		this.set('contact', this.contact);
		this.set('attachments', this.attachments.getChangedModels());
	}
});

PJQ.models.dailyReports.InspectionLogAttachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'inspectionlogs',
				value: this.get('logId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

//Collections
PJQ.collections.dailyReports.InspectionLogs = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.InspectionLog
});

PJQ.collections.dailyReports.InspectionLogAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.InspectionLogAttachment
});